{
  "list": {
    "title": "Partners & contracts",
    "subtitle": "Partners and their contracts",
    "new": "New partner",
    "filterLabel": "Filter partners",
    "all": "All",
    "inactive": "Inactive",
    "empty": "No partners",
    "activeContracts": "Active contracts",
    "bookingsThisMonth": "Bookings this month",
    "noActiveContract": "No active contract",
    "expiresIn": "Contract ends in {{n}} days",
    "expiresOn": "Contract ends {{date}}",
    "noEndDate": "Active contract with no end date",
    "newDialogTitle": "New partner",
    "inContract": "In contract"
  },
  "form": {
    "name": "Name",
    "nameRequired": "Name is required",
    "type": "Type",
    "typeRequired": "Choose a partner type",
    "typePlaceholder": "Choose a type",
    "inactiveOption": "{{name}} (inactive)",
    "crNumber": "Commercial registration",
    "contactFirstName": "Contact — first name",
    "contactLastName": "Contact — last name",
    "phone": "Mobile",
    "email": "Email",
    "save": "Save details",
    "add": "Add partner",
    "saved": "Details saved",
    "added": "Partner added",
    "saveFailed": "Couldn't save",
    "inContract": "Include the platform in the coordinator contract (Annex B)",
    "inContractHint": "On save, every coordinator with a contract is emailed an additional annex to sign online, and new contracts list the platform.",
    "inContractHintExisting": "Removing it affects new contracts only; signed contracts and annexes stay as they are.",
    "annexSent": "An additional annex will be sent to coordinators to sign"
  },
  "detail": {
    "edit": "Edit details",
    "expiringBanner": "The “{{title}}” contract ends on {{date}}. Renew the contract with the partner.",
    "contracts": "Contracts",
    "noContracts": "No contracts uploaded.",
    "contractMeta": "{{start}} – {{end}} · {{size}} · Uploaded by {{by}}",
    "editDialogTitle": "Edit partner"
  },
  "upload": {
    "title": "Upload a new contract",
    "contractTitle": "Contract title",
    "start": "Starts",
    "end": "Ends",
    "endBeforeStart": "Must be after the start date",
    "storedInDb": "Stored in the database",
    "progress": "Upload progress",
    "submit": "Upload contract",
    "uploaded": "Contract uploaded",
    "failed": "Couldn't upload the contract"
  },
  "info": {
    "title": "Partner details",
    "type": "Type",
    "crNumber": "Commercial registration",
    "contact": "Contact",
    "phone": "Mobile",
    "email": "Email",
    "bookingsThisMonth": "Bookings this month"
  },
  "toggle": {
    "deactivate": "Deactivate partner",
    "activate": "Activate partner",
    "deactivated": "Partner deactivated",
    "activated": "Partner activated"
  }
}
